import {connect} from 'react-redux'
import SidebarReports from 'components/SidebarReports'
import {
  servedByPageRequest,
  changeDateServedBy,
  changeOutletServedBy,
  exportServedBy
} from 'actions/reports/sales'
import styles from './ServedBy.css'
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay'
import moment from 'moment'
import {formValueSelector} from 'redux-form'
import ActionBar from '../ActionBar'
import LoadingSpinner from 'components/LoadingSpinner'
import TableWithoutChild from 'components/TableReportSales/TableWithoutChild'
import {rupiahWithNegativeWithoutBracket} from 'utils/formatter'
import _ from 'lodash'
import {browserHistory} from 'react-router'
import * as mpServedBy from 'mixpanel/reports/served'

class ServedBy extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(servedByPageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      openSidebar: false
    }
  }

  render () {
    let {servers, showLoadingSpinnerReport} = this.props.data.reports.servers
    let [footBody, childBody] = this._formatDataForList(servers)
    let footBodyResponsive = this._formatFootBody(_.cloneDeep(footBody))
    let childBodyResponsive = this._formatChildBody(_.cloneDeep(childBody))

    return (
      <div id='reports-sales-served-by' className={`${styles.wrapper}`}>
        <ActionBar onChangeDate={this._onChangeDate} onChangeOutlet={this._onChangeOutlet} onExport={this._onClickExport} />
        <div className='mk-report-sales full-height'>
          <div className='row full-height'>
            <SidebarReports elementClass='visible-lg visible-md slideMenuWeb' location={this.props.location} />
            <SidebarReports elementClass={'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : '')} onToggle={this._toogleSidebar} location={this.props.location} />
            <div className='col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height'>
              <div className='mk-report-sales-content full-height'>
                <div className='mk-burger-box visible-xs visible-sm'>
                  <div className='mk-burger'>
                    <button type='button' className='navbar-toggle collapsed navbar-burger' onClick={this._showSidebar} data-toggle='collapse' >
                      <span className='sr-only'>Toggle navigation</span>
                      <span className='icon-bar' />
                      <span className='icon-bar' />
                      <span className='icon-bar' />
                    </button>
                  </div>
                </div>
                <div className={styles.tableWrapper + ' visible-md visible-lg'}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
                  {servers.servers && servers.servers.length > 0 &&
                    <TableWithoutChild
                      headerBody={['Name', 'Title', 'Number of Transactions', 'Total Collected']}
                      childBody={childBody}
                      footBody={footBody}
                      tableClass='server-by-table'
                      headerBodyClassName={['header-name', 'header-titla', 'header-number-of-transaction', 'header-total-collected']}
                      childBodyClassName={['body-name', 'body-titla', 'body-number-of-transaction', 'body-total-collected']}
                      footBodyClassName={['foot-name', 'foot-titla', 'foot-number-of-transaction', 'foot-total-collected']} />
                    }
                  {servers.servers && !servers.servers.length && !showLoadingSpinnerReport &&
                    <div className='no-data-display-container'>
                      <NoDataDisplay title='No Data to Display' />
                    </div>}
                </div>
                <div className={styles.tableWrapperResponsive + ' visible-xs visible-sm'}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
                  {servers.servers && servers.servers.length > 0 &&
                    <TableWithoutChild
                      headerBody={['Name', 'Number of Transactions', 'Total Collected']}
                      childBody={childBodyResponsive}
                      footBody={footBodyResponsive}
                      tableClass='server-by-table-responsive'
                      headerBodyClassName={['header-name', 'header-number-of-transaction', 'header-total-collected']}
                      childBodyClassName={['body-name', 'body-number-of-transaction', 'body-total-collected']}
                      footBodyClassName={['foot-name', 'foot-number-of-transaction', 'foot-total-collected']} />}
                  {servers.servers && !servers.servers.length && !showLoadingSpinnerReport &&
                    <div className='no-data-display-container'>
                      <NoDataDisplay title='No Data to Display' />
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _formatDataForList = (servers) => {
    let childBody = []
    let footBody = {
      name: 'Total',
      title: null,
      total_number_transaction: servers.total_number_transaction,
      total_collected: rupiahWithNegativeWithoutBracket(servers.total_collected)
    }
    if (servers.servers) {
      servers.servers.map(function (server) {
        childBody.push({
          server_name: server.server_name,
          server_title: server.server_title,
          number_transaction: server.number_transaction,
          collected: rupiahWithNegativeWithoutBracket(server.collected)
        })
      })
    }
    return [footBody, childBody]
  }

  _formatFootBody = (footBody) => {
    delete footBody.title
    return footBody
  }

  _formatChildBody = (childBody) => {
    let result = []
    childBody.map(function (val) {
      delete val.server_title
      result.push(val)
    })
    return result
  }

  _onChangeOutlet = (outletIds = []) => {
    let {startDate, endDate} = this.props.search.date
    mpServedBy.reportServedChangeFilter({
      outletIds,
      startDate,
      endDate
    })
    this.props.dispatch(changeOutletServedBy({outletIds, startDate, endDate}))
  }

  _showSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar})
  }

  _toogleSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar})
  }

  _onChangeDate = ({startDate, endDate}) => {
    const {outlet} = this.props.search
    mpServedBy.reportServedChangeFilter({
      outletIds: outlet,
      startDate,
      endDate
    })
    this.props.dispatch(changeDateServedBy(startDate.toDate(), endDate.toDate()))
  }

  _onClickExport = () => {
    let {startDate, endDate} = this.props.search.date
    const outlet = this.props.search.outlet

    let query = {start: moment(startDate).format('D/M/Y'), end: moment(endDate).format('D/M/Y')}
    let dateLabel = startDate.isSame(endDate, 'days') ? moment(startDate).format('DD-MM-YYYY') : [moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY')].join(' - ')
    let filename = 'Report Server - ' + dateLabel
    mpServedBy.reportServedExport({
      outletIds: outlet,
      startDate,
      endDate
    })
    this.props.dispatch(exportServedBy(query, filename, outlet[0]))
  }
}

const selector = formValueSelector('search')

function select (state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        servers: state.reports.servers
      },
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(select)(ServedBy)



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/ServedBy/ServedBy.js